import { createElement, PropsWithChildren } from 'react';
import { use100vh } from 'react-div-100vh';

type FullHeightProps = PropsWithChildren<{
  tag?: 'div' | 'main' | 'section' | 'article' | 'header' | 'footer' | 'aside';
  divider?: number;
  className?: string;
}>;

const FullHeight = ({
  tag = 'div',
  divider = 1,
  className,
  children,
}: FullHeightProps) => {
  const height = use100vh();

  const totalHeight = height ? height / divider : '100vh';

  return createElement(
    tag,
    {
      style: {
        minHeight: totalHeight,
      },
      className,
      'data-testid': 'fullheight',
    },
    children
  );
};

export default FullHeight;
